import {
  SquarePen,
  FilePlus2,
  Settings,
  Package,
  Target,
  Shield,
  Upload,
  FileText,
  User,
  Briefcase,
  FilePlus,
  DollarSign,
  Home,
  Minus,
  ClipboardList,
  CheckCircle,
  FolderOpen,
  Files,
} from "lucide-react"
import type { NavItem } from "./sidebar-menu-item"

export const NEW_CHAT_ACTION = "new-chat" as const

export type SidebarMode = "policy-engine" | "banker-interface" | "schema-management"

export interface NavigationConfig {
  mode: SidebarMode
  modeLabel: string
  modeSubtitle?: string
  groupLabel?: string
  items: NavItem[]
}

export interface GetNavigationConfigOptions {
  isInsideApplicationFlow?: boolean
}

const policyEngineNav: NavigationConfig = {
  mode: "policy-engine",
  modeLabel: "Policy Engine",
  items: [
    {
      title: "New chat",
      icon: SquarePen,
      url: "/agent/policy",
      action: NEW_CHAT_ACTION,
    },
    {
      title: "Submit",
      icon: FilePlus2,
      url: "/submit",
      disabled: true,
    },
    {
      title: "Settings",
      icon: Settings,
      url: "/settings",
      disabled: true,
    },
  ],
}

const bankerInterfaceLandingNav: NavigationConfig = {
  mode: "banker-interface",
  modeLabel: "Banker",
  modeSubtitle: "Interface",
  items: [
    {
      title: "Applications",
      icon: FolderOpen,
      url: "/agent/application",
    },
    {
      title: "Settings",
      icon: Settings,
      url: "/agent/application/settings",
    },
  ],
}

const bankerInterfaceFlowNav: NavigationConfig = {
  mode: "banker-interface",
  modeLabel: "Banker",
  modeSubtitle: "Interface",
  groupLabel: "Loan Application",
  items: [
    {
      title: "Product",
      icon: Package,
      step: 0,
    },
    {
      title: "Goal",
      icon: Target,
      step: 1,
    },
    {
      title: "Consent",
      icon: Shield,
      step: 2,
    },
    {
      title: "Upload Documents",
      icon: Upload,
      step: 3,
      badge: "counter", // Special badge for document counter
    },
    {
      title: "Loan Application Details",
      icon: FileText,
      step: 4,
    },
    {
      title: "Applicant Details",
      icon: User,
      step: 5,
    },
    {
      title: "Employment",
      icon: Briefcase,
      step: 6,
    },
    {
      title: "Income",
      icon: FilePlus,
      step: 7,
    },
    {
      title: "Expenses",
      icon: DollarSign,
      step: 8,
    },
    {
      title: "Assets",
      icon: Home,
      step: 9,
    },
    {
      title: "Liabilities",
      icon: Minus,
      step: 10,
    },
    {
      title: "Review",
      icon: ClipboardList,
      step: 11,
    },
    {
      title: "Outcome",
      icon: CheckCircle,
      step: 12,
    },
  ],
}

const schemaManagementNav: NavigationConfig = {
  mode: "schema-management",
  modeLabel: "Schema Management",
  items: [
    {
      title: "Document Types",
      icon: FileText,
      url: "/agent/document",
    },
    {
      title: "Extract Data",
      icon: Files,
      url: "/agent/document/extract",
    },
    {
      title: "Settings",
      icon: Settings,
      url: "/agent/document/settings",
    },
  ],
}

export const navigationConfigs: Record<SidebarMode, NavigationConfig> = {
  "policy-engine": policyEngineNav,
  "banker-interface": bankerInterfaceFlowNav,
  "schema-management": schemaManagementNav,
}

export function getNavigationConfig(mode: SidebarMode, options?: GetNavigationConfigOptions): NavigationConfig {
  if (mode === "banker-interface") {
    return options?.isInsideApplicationFlow ? bankerInterfaceFlowNav : bankerInterfaceLandingNav
  }
  return navigationConfigs[mode]
}
